import './ResponsiveTable.css';
import './ResponsiveTableLayout.css';
import './ResizableTable.css';

import { Table, OverlayTrigger, Tooltip, Card, Form, Row, Col, Container, Image, Button, } from "react-bootstrap";
import Search from './Search';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import Sort from './Sort';
import Pagination from './Pagination';
import Filter from './Filter';
import GlobalSearch from './GlobalSearch';
import ExcelDownload from './ExcelDownload';
import ChunkedExcelDownload from './ChunkedExcelDownload';
import constants from '../../helpers/constants';
import Switch from '../common/Switch';
import plus from "../../assets/plus.svg"
import ColumnGrid from './ColumnGrid'
import xFilter from "../../assets/x-filter.svg"
import { searchAll } from './common-filter';
import { resizableColumn } from './ResizableTable';
import Upload from './Upload';

export default function ResponsiveTable(props) {
    const [data, setData] = useState([]);
    const [pageSize] = useState(props.pageSize ? props.pageSize : 8);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchList, setSearchList] = useState({});
    const [showDownButn, setShowDownButn] = useState(true);
    const [writeAccess, setWriteAccess] = useState(false);
    const [sortList, setSortList] = useState({});
    const [gridHeader, setGridHeader] = useState(props.headers);
    const [selectedData, setSelectedData] = useState(props.selectedData ? props.selectedData : []);
    const [activeColumn, setActiveColumn] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    const [showMore, setShowMore] = useState({});
    const [statusColumn, setStatusColumn] = useState("status")
    const [showUpload, setShowUpload] = useState(false);

    useEffect(() => {
        let propsTemp = { setData: setData, data: props.data, header: gridHeader };
        searchAll(propsTemp, searchList)    
        setSortList({})
        setSelectAll(false)
        setCurrentPage(1);
    }, [props.data])

    useEffect(() => {
        setSearchList({})
    }, [props.dataType])

    useEffect(() => {
        setGridHeader(props.headers)
        let count = 0
        for (let header of props.headers) {
            if (header.displayIndication == true) {
                count = count + 1
            }
            if (header.status == true) {
                setStatusColumn(header.columnName);
            }
        }
        setActiveColumn(count)
    }, [props.headers])

    useEffect(() => {
        if (props.dataType) {
            resizableColumn(props.dataType + "_table");
        }
    }, [gridHeader])

    useEffect(() => {
        setSelectedData(props.selectedData ? props.selectedData : [])
    }, [props.selectedData])

    useEffect(() => {
        if (props.setSelectedData) {
            props.setSelectedData(selectedData)
        }
    }, [selectedData])

    useEffect(() => {
        // Use the canWrite prop if provided, otherwise calculate from session
        if (props.canWrite !== undefined) {
            setWriteAccess(props.canWrite);
            return;
        }
        
        let AuthorizedSessionstmp = sessionStorage.getItem("AuthorizedSessions");
        let AuthorizedSessions = AuthorizedSessionstmp !== "" ? JSON.parse(AuthorizedSessionstmp) : {};
        for (let parentMenu in AuthorizedSessions) {
            if (AuthorizedSessions[parentMenu]) {
                for (let menu of AuthorizedSessions[parentMenu]) {
                    if (menu.subMenu == props.sessionName && menu.write) {
                        setWriteAccess(true)
                        break;
                    }
                }
            }
        }
    }, [props.sessionName, props.canWrite])
    const filteredResult = useMemo(() => {
        setShowMore({});
        let firstPageIndex = 0;
        if (currentPage > 1) {
            firstPageIndex = (currentPage - 1) * pageSize;
        }
        if (firstPageIndex >= data?.length) {
            firstPageIndex = 0;
            const totalPageCount = Math.ceil(data?.length / pageSize);
            if (totalPageCount > 0) {
                setCurrentPage(totalPageCount)
            } else {
                setCurrentPage(1)
            }
        }

        let lastPageIndex = parseInt(firstPageIndex) + parseInt(pageSize);
        return data && data.length ? data.slice(firstPageIndex, lastPageIndex) : [];
    }, [currentPage, data, pageSize]);

    const handleChangeCheckbox = (e, item) => {
        let tempSelectedData = []
        Object.assign(tempSelectedData, selectedData);
        if (e.target.checked) {
            tempSelectedData.push(item);
        } else {
            const index = tempSelectedData.findIndex((element) => element.itemKeyId === item.itemKeyId);
            if (index !== -1) {
                tempSelectedData.splice(index, 1);
            }
        }
        setSelectedData(tempSelectedData);
        if (props.setSelectedData) {
            props.setSelectedData(tempSelectedData)
        }

        if (tempSelectedData.length == data.length) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    }
    const handleSelectAll = (e) => {
        let tempdata = []
        if (e.target.checked) {
            for (let item of data) {
                if (props.checkBoxValidation == undefined || props.checkBoxValidation(item)) {
                    tempdata.push(item);
                }
            }
            for (let item of selectedData) {
                if (props.checkBoxValidation == undefined || props.checkBoxValidation(item)) {
                    const index = tempdata.findIndex((element) => element.itemKeyId === item.itemKeyId);
                    if (index === -1) {
                        tempdata.push(item);
                    }
                }
            }
        }
        setSelectedData(tempdata);
        if (props.setSelectedData) {
            props.setSelectedData(tempdata)
        }
        setSelectAll(e.target.checked)
    };

    const handleShowMore = (index) => {
        if (showMore[index]) {
            setShowMore((prev) => ({ ...prev, [index]: false }));
        }
        else {
            setShowMore((prev) => ({ ...prev, [index]: true }));
        }
    }


    return (<Container bsPrefix='custom-grid'>
        <Row bsPrefix='grid'>
            <Row className="global-search-bar">
                <Col bsPrefix='search-col'>
                    {props.handleAdd && <Button className={`add-btn ${!showDownButn ? "hide" : ""} ${writeAccess == false ? "disabled" : ""}`} onClick={props.handleAdd}><span className="add-btn-label">Add {props.button}<Image className="add-btn-img" src={plus}></Image></span></Button>}
                    {props.handleUpload && writeAccess && <Button className={`add-btn import-btn ${!showDownButn ? "hide" : ""}`} onClick={() => setShowUpload(true)} disabled={props.uploadLoading}>{props.uploadLoading ? 'Importing data...' : 'Import'}</Button>}
                    {props.customButtons && <props.customButtons data={props.data} setData={setData} selectedData={selectedData}></props.customButtons>}
                    <div className='search-bar-right'>  <div className='global-search'> <GlobalSearch className="global-search-col " setData={setData} headers={gridHeader} data={props.data} setShowDownButn={setShowDownButn} showDownButn={showDownButn} isSearchOpen={props.isSearchOpen} searchList={searchList} dataType={props.dataType}></GlobalSearch></div>
                        {props.DisplayColumnChooser && <ColumnGrid className="column-selector" headers={gridHeader} setGridHeader={setGridHeader} />}
                        {(selectedData.length > 0) && props.DisplayExcelDownload && (
                            selectedData.length > 10000 ?
                                <ChunkedExcelDownload downloadData={true} fileName={props.dataType} className="download-btn-col" headers={props.headers} data={selectedData} /> :
                                <ExcelDownload downloadData={true} fileName={props.dataType} className="download-btn-col" headers={props.headers} data={selectedData} />
                        )}
                    </div>
                </Col>
            </Row>
            <Row className='filter-selected-row'><Col className='filter-selected-col gap-2'>{searchList && Object.keys(searchList).map((key, index) => {
                let filterValueSelected = searchList[key][0] && searchList[key][0] != "" ? searchList[key].displayName + ": " + searchList[key][0] : "";
                filterValueSelected = searchList[key][1] && searchList[key][1] != "" && searchList[key].condition != "" ? filterValueSelected + " " + searchList[key].condition + " " + searchList[key][1] : filterValueSelected;
                if (searchList[key].filterType == "Range") {
                    filterValueSelected = searchList[key][1] && searchList[key][1] != "" ? filterValueSelected + " To " + searchList[key][1] : filterValueSelected;
                }
                if (searchList[key].filterType == "Blank" || searchList[key].filterType == "Not Blank") {
                    filterValueSelected = searchList[key].displayName + ":" + searchList[key].filterType;
                }
                if (key == "GlobalSearch") {
                    filterValueSelected = "";
                }
                return (<React.Fragment key={index}> {filterValueSelected && <div className='filter-selected'>
                    <span className='filter-selected-label'>{filterValueSelected} </span>
                    <Image className='filter-selected-cross' src={xFilter} onClick={() => {
                        searchList[key][0] = "";
                        searchList[key][1] = "";
                        searchList[key].filterType = "";
                        let propsTemp = { setData: setData, data: props.data, header: gridHeader };
                        searchAll(propsTemp, searchList)
                    }}></Image></div>}</React.Fragment>)
            })}</Col></Row>
            <Container bsPrefix='custom-grid-table'>
                <Table className="responsiveTable" id={props.dataType + "_table"}>
                    <thead>
                        <tr>
                            <th className='fixed' style={{ left: 0, "width": '8px' }}></th>
                            {!props.noCheckbox && <th className='fixed' style={{ left: "8px", "width": "23px" }}>
                                <Form.Check className='table-checkbox' name="select"
                                    onChange={handleSelectAll} checked={selectAll}
                                ></Form.Check>
                            </th>}
                            {gridHeader.map((header, index) =>
                            // for hide show column
                            {
                                return (header.displayIndication &&
                                    <th key={props.dataType + "_table" + index} className={`${header.fixed ? "fixed" : ""}`} style={{ "width": header.width + "px", right: header.right }}  > <div className='table-th'>{header.displayName}
                                        <Sort data={data} setData={setData} sortList={sortList} setSortList={setSortList} field={header.columnName}></Sort>
                                        <Filter
                                            index={index}
                                            data={props.data}
                                            columnName={header.columnName}
                                            displayName={header.displayName}
                                            setData={setData}
                                            searchList={searchList}
                                            dataType={header.dataType}
                                            header={gridHeader}
                                        />
                                    </div>
                                    </th>
                                )
                            }
                            )}
                            {props.icons && <th className="fixed icon" style={{ right: 0, minWidth: props?.icons?.length * 17 + 40 + "px" }}>
                                {props?.icons?.map((icon, index) =>
                                    <div key={index}>&nbsp;</div>
                                )
                                }
                            </th>}
                            {/* {props.icons?.length > 0 && <th></th>} */}
                        </tr>
                        {/* <tr><td></td>
                    {props.headers.map((header, index) =>
                        <td key={index}><Search masterData={props.data} index={index}
                            length={props?.headers?.length}
                            setData={setData} data={data} columnName={header.columnName}
                            searchList={searchList} dataType={header.dataType} displayName={header.displayName}
                        ></Search></td>
                    )}
                    {props.icons?.length > 0 && <th></th>}
                </tr> */}
                    </thead>
                    <tbody>
                        {filteredResult.map((item, itemIndex) => {
                            item.itemKeyId = item[Object.keys(item)[0]] + "-index-" + itemIndex;
                            return (
                                <tr key={itemIndex}>
                                    <td className={`status ${item[statusColumn]} fixed`} style={{ left: 0, "width": "8px" }}></td>
                                    {!props.noCheckbox && <td className="fixed" style={{ left: "8px", "width": "23px" }}>
                                        {(props.checkBoxValidation == undefined || props.checkBoxValidation(item)) &&
                                            <Form.Check name="select"
                                                checked={selectedData?.length > 0 ? (selectedData.filter(e => e.itemKeyId === item.itemKeyId).length <= 0) ? false : true : false
                                                }
                                                className='table-checkbox'
                                                onChange={(e) => {
                                                    handleChangeCheckbox(e, item);
                                                }} ></Form.Check>
                                        }
                                    </td>}
                                    {gridHeader.map((header, index) =>
                                    // for hide show column
                                    {
                                        let formattedValue = header.formatter ? header.formatter(item[header.columnName], header, item) : item[header.columnName];
                                        let displayValue = header.cssFormatter ? header.cssFormatter(formattedValue, header, item) : formattedValue;
                                        return (header.displayIndication &&
                                            <td key={itemIndex + " " + index} className={`${header.fixed ? "fixed" : ""}`} style={{ right: header.right }}>
                                                <div className={`responsive-td ${displayValue}`} >

                                                    {header.switch && <>
                                                        <Switch
                                                            isOn={formattedValue == constants.ACTIVE ? true : false}
                                                            index={itemIndex}
                                                            disabled={!writeAccess}
                                                            handleToggle={() => {
                                                                if (writeAccess) {
                                                                    item[statusColumn] = formattedValue == constants.ACTIVE ? constants.INACTIVE : constants.ACTIVE;
                                                                    header.setStatus(item)
                                                                }
                                                            }}
                                                        ></Switch> {displayValue} </>}
                                                    {!header.switch && <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formattedValue}</Tooltip>}
                                                    ><div className='table-display-value'>{displayValue}</div></OverlayTrigger>}
                                                </div>
                                            </td>
                                        )
                                    }
                                    )}
                                    {props.icons && <td className="fixed icon" style={{ right: 0, minWidth: props?.icons?.length * 17 + 40 + "px" }}>
                                        {props.icons?.map((icon, index) =>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip>{icon.iconName}</Tooltip>}><Image width={"17px"} className={`table-icon ${writeAccess == false ? "disabled" : ""}`} key={index} src={icon.src} pointer="Cursor" onClick={() => { if (writeAccess) { icon.click(item) } }}></Image></OverlayTrigger>
                                        )}
                                    </td>}
                                </tr>
                            )
                        })}

                        {filteredResult.length < 1 && <tr><td colSpan={activeColumn + 1 + (props.icons ? 1 : 0) + (props.noCheckbox ? 0 : 1)}><div className='responsive-td'>No records to show</div></td></tr>}
                    </tbody>
                </Table>
            </Container>
            <div className="responsive-div">
                {filteredResult.map((item, itemIndex) => {
                    item.itemKeyId = item[Object.keys(item)[0]] + "-index-" + itemIndex;
                    return (
                        <Card key={itemIndex} className={`responsive-card mb-3 ${item[statusColumn]} ${activeColumn >= 5 ? "show-more-less" : ""} ${showMore[itemIndex] ? "show-more" : "show-less"}`}>
                            <Card.Header className="responsive-card-header">
                                {!props.noCheckbox && <div>
                                    {(props.checkBoxValidation == undefined || props.checkBoxValidation(item)) &&
                                        <Form.Check name="select"
                                            checked={selectedData?.length > 0 ? (selectedData.filter(e => e.itemKeyId === item.itemKeyId).length <= 0) ? false : true : false
                                            }
                                            className='table-checkbox'
                                            onChange={(e) => {
                                                handleChangeCheckbox(e, item);
                                            }} ></Form.Check>
                                    }
                                </div>}
                                <div>
                                    {props.icons?.map((icon, index) => <>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>{icon.iconName}</Tooltip>}><Image className={`responsive-card-icon ${writeAccess == false ? "disabled" : ""}`} key={index} src={icon.src} onClick={() => { if (writeAccess) { icon.click(item) } }}></Image></OverlayTrigger>
                                    </>)}
                                </div>
                            </Card.Header>
                            <Card.Body className={`responsive-card-body`}>
                                {gridHeader.map((header, index) =>
                                // for hide show column
                                {
                                    let formattedValue = header.formatter ? header.formatter(item[header.columnName], header, item) : item[header.columnName];
                                    let displayValue = header.cssFormatter ? header.cssFormatter(formattedValue, header, item) : formattedValue;
                                    return (header.displayIndication != undefined &&
                                        <Card.Body key={index} className={`responsive-row`}>
                                            <span className="responsive-header">{header.displayName}</span>
                                            <span className={`responsive-value ${displayValue}`}>
                                                {header.switch &&
                                                    <Switch
                                                        isOn={formattedValue == constants.ACTIVE ? true : false}
                                                        index={itemIndex}
                                                        disabled={!writeAccess}
                                                        handleToggle={() => {
                                                            if (writeAccess) {
                                                                item[statusColumn] = formattedValue == constants.ACTIVE ? constants.INACTIVE : constants.ACTIVE;
                                                                header.setStatus(item)
                                                            }
                                                        }}
                                                    ></Switch>}
                                                {displayValue}</span>
                                        </Card.Body>
                                    )
                                }
                                )}
                            </Card.Body>
                            <Card.Footer className={`responsive-card-footer`}>
                                <span className="responsive-card-show-more" onClick={() => { handleShowMore(itemIndex) }}>{showMore[itemIndex] ? "Show less" : "Show More"}</span>
                            </Card.Footer>
                        </Card>
                    )
                })}
            </div>
        </Row>
        <Pagination
            currentPage={currentPage}
            totalCount={data ? data.length : 0}
            data={data}
            pageSize={pageSize}
            setCurrentPage={setCurrentPage}
            dataType={props.dataType}
        />
        {showUpload && <Upload
            dataType={props.dataType}
            showUpload={showUpload}
            setShowUpload={setShowUpload}
            headers={props.headers}
            handleUpload={props.handleUpload}
            setReload={() => { props.setReload(!props.reload) }}
            productdata={props.productdata}
            handleApi={props.handleApi}
            setUploadLoading={props.setUploadLoading}
        ></Upload>}
    </Container >
    )
}